"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var MonitoringCategory_1 = __importDefault(require("./MonitoringCategory"));
function Monitoring() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MonitoringCategory_1.default, null),
        react_1.default.createElement(HeaderBar_1.default, { title: "monitoring" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, " hello")))));
}
exports.default = Monitoring;
